import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sso-success-dialog",
  "use": "icon-sso-success-dialog-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sso-success-dialog\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-4.795-1.545a.998.998 0 0 0-1.41-1.41L10.5 14.339l-2.295-2.294a.997.997 0 1 0-1.41 1.41l3 3a.998.998 0 0 0 1.41 0l6-6Z\" fill=\"#069A49\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol